import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCabinLuggage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#17181A"
    {...props}
  >
    <rect x={3.5} y={8.5} width={17} height={13} rx={1.5} />
    <path d="M17 9c0-2.21-2.239-4-5-4S7 6.79 7 9" />
  </svg>
);
const Memo = memo(SvgCabinLuggage);
export default Memo;
